module.exports = __webpack_public_path__ + "img/alba1.399a6f78.png";